var map = {
	"./App": 10788,
	"./App.vue": 10788,
	"./assets/about/Group.png": 31009,
	"./assets/about/Group2.png": 3143,
	"./assets/about/Group3.png": 34302,
	"./assets/about/food.png": 67038,
	"./assets/about/food2.jpeg": 67239,
	"./assets/about/pay.png": 46230,
	"./assets/about/people.png": 61255,
	"./assets/about/people2.png": 67541,
	"./assets/about/title.png": 17494,
	"./assets/about/title2.png": 3734,
	"./assets/about/title3.png": 57535,
	"./assets/about/title4.png": 29504,
	"./assets/baozang.gif": 18417,
	"./assets/browse/off-icon.png": 34284,
	"./assets/browse/search_icon.png": 18811,
	"./assets/browse/shop_car_empty.png": 51062,
	"./assets/contact/add.png": 87954,
	"./assets/contact/email.png": 25003,
	"./assets/contact/icon1.png": 41931,
	"./assets/contact/icon2.png": 28112,
	"./assets/contact/icon3.png": 34361,
	"./assets/contact/icon4.png": 93209,
	"./assets/contact/icon5.png": 97135,
	"./assets/contact/icon6.png": 92020,
	"./assets/contact/icon7.png": 13149,
	"./assets/contact/icon8.png": 86026,
	"./assets/contact/phone.png": 40543,
	"./assets/contact/wx.png": 98918,
	"./assets/contact/x.png": 72275,
	"./assets/cuisine/Asian/Asian1.png": 13931,
	"./assets/cuisine/Asian/Asian2.png": 112,
	"./assets/cuisine/Asian/Asian3.png": 6361,
	"./assets/cuisine/Burgers/burgers1.png": 73899,
	"./assets/cuisine/Burgers/burgers2.png": 60080,
	"./assets/cuisine/Burgers/burgers3.png": 66329,
	"./assets/cuisine/Chinese/Chinese1.png": 93591,
	"./assets/cuisine/Chinese/Chinese2.png": 4860,
	"./assets/cuisine/Chinese/Chinese3.png": 22373,
	"./assets/cuisine/Indian/img1.png": 51623,
	"./assets/cuisine/Indian/img2.png": 31564,
	"./assets/cuisine/Indian/img3.png": 661,
	"./assets/cuisine/Japanese/Japanese1.png": 5695,
	"./assets/cuisine/Japanese/Japanese2.png": 20420,
	"./assets/cuisine/Japanese/Japanese3.png": 83661,
	"./assets/cuisine/Kebabs/Kebabs1.png": 54773,
	"./assets/cuisine/Kebabs/Kebabs2.png": 34398,
	"./assets/cuisine/Korean/Korean1.png": 60017,
	"./assets/cuisine/Korean/Korean2.png": 83770,
	"./assets/cuisine/Korean/Korean3.png": 89955,
	"./assets/cuisine/Pizza/Pizza1.png": 33855,
	"./assets/cuisine/Pizza/Pizza2.png": 48580,
	"./assets/cuisine/Pizza/Pizza3.png": 11821,
	"./assets/cuisine/Thai/Thai1.png": 18785,
	"./assets/cuisine/Thai/Thai2.png": 69802,
	"./assets/cuisine/Thai/Thai3.png": 20563,
	"./assets/cuisine/cuisine_bg_1.png": 93625,
	"./assets/cuisine/cuisine_bg_2.png": 79618,
	"./assets/cuisine/cuisine_bg_3.png": 43275,
	"./assets/cuisine/cuisine_bg_4.png": 51284,
	"./assets/cuisine/cuisine_desc_demo.png": 90473,
	"./assets/flag/Flag_of_Portugal.png": 99584,
	"./assets/flag/Romania.png": 93738,
	"./assets/flag/Sweden.png": 31747,
	"./assets/flag/a-Austriaaodiliguoqi.png": 21587,
	"./assets/flag/a-Belgiumbilishiguoqi.png": 22655,
	"./assets/flag/a-Danmarkdanmaiguoqi.png": 19818,
	"./assets/flag/a-Finlandfenlanguoqi.png": 60236,
	"./assets/flag/a-Greekxilaguoqi.png": 67488,
	"./assets/flag/a-Holandhelanguoqi.png": 24778,
	"./assets/flag/a-Irelandaierlanguoqi.png": 31593,
	"./assets/flag/a-Italyyidaliguoqi.png": 76361,
	"./assets/flag/a-Norwaynuoweiguoqi.png": 47779,
	"./assets/flag/a-Swedenruidianguoqi.png": 52400,
	"./assets/flag/america.png": 2715,
	"./assets/flag/aodaliya.png": 217,
	"./assets/flag/bingdao.png": 29529,
	"./assets/flag/canada.png": 55841,
	"./assets/flag/china.png": 73726,
	"./assets/flag/deguoguoqi.png": 22662,
	"./assets/flag/france.png": 93478,
	"./assets/flag/hungary.png": 73721,
	"./assets/flag/maerta.png": 75909,
	"./assets/flag/poland.png": 64312,
	"./assets/flag/ruishi.png": 90845,
	"./assets/flag/saipulusi.png": 26906,
	"./assets/flag/siluofake.png": 37008,
	"./assets/flag/siluowenniya.png": 1160,
	"./assets/flag/uk.png": 63459,
	"./assets/flag/xibanyaguoqi.png": 98324,
	"./assets/icon/book_icon.png": 56647,
	"./assets/icon/facebook.png": 87540,
	"./assets/icon/facebook.svg": 72852,
	"./assets/icon/google.png": 20149,
	"./assets/icon/heart.png": 57214,
	"./assets/icon/heart_fill.png": 23584,
	"./assets/icon/icon_card.png": 16834,
	"./assets/icon/icon_cash.png": 35865,
	"./assets/icon/icon_cash_eur.png": 85660,
	"./assets/icon/icon_fb.png": 13708,
	"./assets/icon/icon_ins.png": 8426,
	"./assets/icon/icon_paypal.png": 88701,
	"./assets/icon/icon_receipt.svg": 60670,
	"./assets/icon/icon_rights.png": 41737,
	"./assets/icon/icon_stripe.png": 82363,
	"./assets/icon/icon_tw.png": 27771,
	"./assets/icon/icon_viva.png": 49684,
	"./assets/icon/input_search.png": 32423,
	"./assets/icon/insta.svg": 50241,
	"./assets/icon/linkedin.png": 19434,
	"./assets/icon/linkedin.svg": 96718,
	"./assets/icon/sumb_down.png": 1482,
	"./assets/icon/sumb_up.png": 60565,
	"./assets/icon/telegram.png": 73173,
	"./assets/icon/tiktok.svg": 15590,
	"./assets/icon/twitter.svg": 55813,
	"./assets/icon/whiteHeart.png": 44657,
	"./assets/icon/x.png": 91522,
	"./assets/icon/youyube.svg": 34060,
	"./assets/iconfont/iconfont": 53448,
	"./assets/iconfont/iconfont.css": 24714,
	"./assets/iconfont/iconfont.js": 53448,
	"./assets/iconfont/iconfont.json": 92930,
	"./assets/iconfont/iconfont.ttf": 12002,
	"./assets/iconfont/iconfont.woff": 69394,
	"./assets/iconfont/iconfont.woff2": 81172,
	"./assets/images/cuiseNot.png": 46815,
	"./assets/images/discount.png": 75058,
	"./assets/images/download_modal_bg.png": 33527,
	"./assets/images/food.png": 23871,
	"./assets/images/google_download.png": 28211,
	"./assets/images/img_home.png": 3286,
	"./assets/images/ios_download.png": 92281,
	"./assets/images/live_chat.png": 93696,
	"./assets/images/location.png": 64318,
	"./assets/images/login_bg.png": 66392,
	"./assets/images/menu-cuise.png": 50284,
	"./assets/images/mobile_banner.png": 41256,
	"./assets/images/modal_tag.svg": 80047,
	"./assets/images/notfoundBg.png": 63335,
	"./assets/images/order_tips_download.jpg": 92559,
	"./assets/images/profile_default.png": 13074,
	"./assets/images/quotation.png": 13005,
	"./assets/images/right.png": 48349,
	"./assets/images/search.png": 34319,
	"./assets/images/skiLogo.png": 78493,
	"./assets/images/special.png": 84706,
	"./assets/index/app_download_bg.png": 59461,
	"./assets/index/download_index_mobile.png": 6809,
	"./assets/index/icon_index_1.png": 89409,
	"./assets/index/icon_index_2.png": 40426,
	"./assets/index/icon_index_3.png": 91187,
	"./assets/index/icon_index_cate2.png": 66385,
	"./assets/index/icon_index_cate3.png": 68520,
	"./assets/index/index_card.png": 47874,
	"./assets/logo-merchant.png": 6400,
	"./assets/logo.png": 33153,
	"./assets/menu/Shop_light.png": 4583,
	"./assets/menu/empty_cart.png": 16718,
	"./assets/menu/empty_cart2.png": 41406,
	"./assets/menu/empty_cart3.png": 12743,
	"./assets/menu/fhrs_0_en-gb.jpg": 11920,
	"./assets/menu/fhrs_1_en-gb.jpg": 32609,
	"./assets/menu/fhrs_2_en-gb.jpg": 1442,
	"./assets/menu/fhrs_3_en-gb.jpg": 79859,
	"./assets/menu/fhrs_4_en-gb.jpg": 7740,
	"./assets/menu/fhrs_5_en-gb.jpg": 43485,
	"./assets/menu/fhrs_AI_en-gb.jpg": 12196,
	"./assets/menu/fhrs_IR_en-gb.jpg": 25463,
	"./assets/menu/fhrs_P_en-gb.jpg": 71184,
	"./assets/menu/fhrs_pass_en-gb.jpg": 90241,
	"./assets/menu/icon_bounds.png": 58661,
	"./assets/menu/icon_eur.png": 92704,
	"./assets/menu/menu_bg_1.png": 33565,
	"./assets/menu/menu_bg_2.png": 66150,
	"./assets/menu/menu_bg_3.png": 34895,
	"./assets/menu/modal_delivery.png": 16896,
	"./assets/menu/modal_dinein.png": 61075,
	"./assets/menu/modal_pickup.png": 58160,
	"./assets/menu/price-fill.svg": 70921,
	"./assets/merchant_pageloading.gif": 58409,
	"./assets/page_loading.gif": 83975,
	"./assets/points/award.png": 11263,
	"./assets/points/point.png": 62742,
	"./assets/policy/faqs_bg.png": 95320,
	"./components/AppleLogin": 57077,
	"./components/AppleLogin.vue": 57077,
	"./components/BindPhone": 67479,
	"./components/BindPhone.vue": 67479,
	"./components/BrowseComps/AddressSearchInput": 59513,
	"./components/BrowseComps/AddressSearchInput.vue": 59513,
	"./components/BrowseComps/BrowseMerchantBox": 80247,
	"./components/BrowseComps/BrowseMerchantBox.vue": 80247,
	"./components/BrowseComps/BrowseSortBox": 15757,
	"./components/BrowseComps/BrowseSortBox.vue": 15757,
	"./components/BrowseComps/ChooseAddressModal": 45422,
	"./components/BrowseComps/ChooseAddressModal.vue": 45422,
	"./components/BrowseComps/TagBar": 85284,
	"./components/BrowseComps/TagBar.vue": 85284,
	"./components/CheckoutComps/AddressBox": 80678,
	"./components/CheckoutComps/AddressBox.vue": 80678,
	"./components/CheckoutComps/CheckLoginBlock": 4934,
	"./components/CheckoutComps/CheckLoginBlock.vue": 4934,
	"./components/CheckoutComps/CheckoutCartBox": 37699,
	"./components/CheckoutComps/CheckoutCartBox.vue": 37699,
	"./components/CheckoutComps/DateTimePicker": 49491,
	"./components/CheckoutComps/DateTimePicker.vue": 49491,
	"./components/CheckoutComps/PaymentBox": 36246,
	"./components/CheckoutComps/PaymentBox.vue": 36246,
	"./components/CloudFlareVerify": 78835,
	"./components/CloudFlareVerify.vue": 78835,
	"./components/CooikeDiv": 13280,
	"./components/CooikeDiv.vue": 13280,
	"./components/CustomerService": 33012,
	"./components/CustomerService.vue": 33012,
	"./components/DownloadAppModal": 69944,
	"./components/DownloadAppModal.vue": 69944,
	"./components/FacebookLogin": 93753,
	"./components/FacebookLogin.vue": 93753,
	"./components/Footer": 21674,
	"./components/Footer.vue": 21674,
	"./components/ForgotPassword": 15731,
	"./components/ForgotPassword.vue": 15731,
	"./components/GoogleLogin": 29675,
	"./components/GoogleLogin.vue": 29675,
	"./components/Header": 35422,
	"./components/Header.vue": 35422,
	"./components/IndexComps/CategoryIndex": 68878,
	"./components/IndexComps/CategoryIndex.vue": 68878,
	"./components/IndexComps/DownloadBox": 84028,
	"./components/IndexComps/DownloadBox.vue": 84028,
	"./components/IndexComps/FaqsBox": 57644,
	"./components/IndexComps/FaqsBox.vue": 57644,
	"./components/IndexComps/MerchantBox": 22758,
	"./components/IndexComps/MerchantBox.vue": 22758,
	"./components/JudgeScreenMask": 96074,
	"./components/JudgeScreenMask.vue": 96074,
	"./components/LoadErrorModal": 88438,
	"./components/LoadErrorModal.vue": 88438,
	"./components/LoginForm": 91904,
	"./components/LoginForm.vue": 91904,
	"./components/MenuComps/CartBox": 46813,
	"./components/MenuComps/CartBox.vue": 46813,
	"./components/MenuComps/CategoryBox": 29743,
	"./components/MenuComps/CategoryBox.vue": 29743,
	"./components/MenuComps/MenuBox": 84273,
	"./components/MenuComps/MenuBox.vue": 84273,
	"./components/MenuComps/MerchantOffMobile": 36616,
	"./components/MenuComps/MerchantOffMobile.vue": 36616,
	"./components/MenuComps/ShopStatus": 12639,
	"./components/MenuComps/ShopStatus.vue": 12639,
	"./components/MerchantItem": 80180,
	"./components/MerchantItem.vue": 80180,
	"./components/MyComps/Account": 18443,
	"./components/MyComps/Account.vue": 18443,
	"./components/MyComps/Address": 86450,
	"./components/MyComps/Address.vue": 86450,
	"./components/MyComps/Booking": 59157,
	"./components/MyComps/Booking.vue": 59157,
	"./components/MyComps/Favorite": 32891,
	"./components/MyComps/Favorite.vue": 32891,
	"./components/MyComps/Orders": 4050,
	"./components/MyComps/Orders.vue": 4050,
	"./components/MyComps/Points": 19709,
	"./components/MyComps/Points.vue": 19709,
	"./components/PageLoading": 17623,
	"./components/PageLoading.vue": 17623,
	"./components/PhoneBtn": 48497,
	"./components/PhoneBtn.vue": 48497,
	"./components/SignupComps/SignupForm": 906,
	"./components/SignupComps/SignupForm.vue": 906,
	"./components/Verifition/Verify": 71755,
	"./components/Verifition/Verify.vue": 71755,
	"./components/Verifition/Verify/VerifyPoints": 19806,
	"./components/Verifition/Verify/VerifyPoints.vue": 19806,
	"./components/Verifition/Verify/VerifySlide": 78246,
	"./components/Verifition/Verify/VerifySlide.vue": 78246,
	"./components/Verifition/api": 54437,
	"./components/Verifition/api/": 54437,
	"./components/Verifition/api/index": 54437,
	"./components/Verifition/api/index.js": 54437,
	"./components/Verifition/utils/ase": 90319,
	"./components/Verifition/utils/ase.js": 90319,
	"./components/Verifition/utils/util": 5938,
	"./components/Verifition/utils/util.js": 5938,
	"./config": 7114,
	"./config/": 7114,
	"./config/index": 7114,
	"./config/index.js": 7114,
	"./config/merchantConfig": 50502,
	"./config/merchantConfig.js": 50502,
	"./config/smsApiConfig": 77429,
	"./config/smsApiConfig.js": 77429,
	"./firebase": 41434,
	"./firebase.js": 41434,
	"./main": 58790,
	"./main.js": 58790,
	"./mixins/judgeScreenH5": 33714,
	"./mixins/judgeScreenH5.js": 33714,
	"./mixins/loginMixin": 15370,
	"./mixins/loginMixin.js": 15370,
	"./request": 98601,
	"./request/": 98601,
	"./request/index": 98601,
	"./request/index.js": 98601,
	"./router": 58197,
	"./router/": 58197,
	"./router/index": 58197,
	"./router/index.js": 58197,
	"./utils/app": 74398,
	"./utils/app.js": 74398,
	"./utils/bus": 36991,
	"./utils/bus.js": 36991,
	"./utils/debounce": 21378,
	"./utils/debounce.js": 21378,
	"./utils/domain-helper": 50062,
	"./utils/domain-helper.js": 50062,
	"./utils/domainStats": 85506,
	"./utils/domainStats.js": 85506,
	"./utils/facebook": 32853,
	"./utils/facebook.js": 32853,
	"./utils/getPickTimeList": 76049,
	"./utils/getPickTimeList.js": 76049,
	"./utils/jsencrypt": 74749,
	"./utils/jsencrypt.js": 74749,
	"./utils/judgeUseGoogle": 52692,
	"./utils/judgeUseGoogle.js": 52692,
	"./utils/manageCart": 71244,
	"./utils/manageCart.js": 71244,
	"./utils/payment": 86283,
	"./utils/payment.js": 86283,
	"./utils/seo": 56472,
	"./utils/seo.js": 56472,
	"./utils/timeValidation": 4047,
	"./utils/timeValidation.js": 4047,
	"./views": 36125,
	"./views/": 36125,
	"./views/404": 12835,
	"./views/404.vue": 12835,
	"./views/about": 61409,
	"./views/about/": 61409,
	"./views/about/components/BoxFive": 35194,
	"./views/about/components/BoxFive.vue": 35194,
	"./views/about/components/BoxFour": 29164,
	"./views/about/components/BoxFour.vue": 29164,
	"./views/about/components/BoxOne": 65411,
	"./views/about/components/BoxOne.vue": 65411,
	"./views/about/components/BoxSix": 56487,
	"./views/about/components/BoxSix.vue": 56487,
	"./views/about/components/BoxThree": 70555,
	"./views/about/components/BoxThree.vue": 70555,
	"./views/about/components/BoxTwo": 36756,
	"./views/about/components/BoxTwo.vue": 36756,
	"./views/about/index": 61409,
	"./views/about/index.vue": 61409,
	"./views/bind-phone": 71262,
	"./views/bind-phone.vue": 71262,
	"./views/booking": 34970,
	"./views/booking.vue": 34970,
	"./views/browse/browse": 60702,
	"./views/browse/browse.vue": 60702,
	"./views/category": 32173,
	"./views/category/": 32173,
	"./views/category/foodInfo": 43975,
	"./views/category/foodInfo.js": 43975,
	"./views/category/index": 32173,
	"./views/category/index.vue": 32173,
	"./views/checkout": 307,
	"./views/checkout.vue": 307,
	"./views/contact": 48998,
	"./views/contact/": 48998,
	"./views/contact/index": 48998,
	"./views/contact/index.vue": 48998,
	"./views/demo": 13402,
	"./views/demo.vue": 13402,
	"./views/develop": 6342,
	"./views/develop/": 6342,
	"./views/develop/index": 6342,
	"./views/develop/index.vue": 6342,
	"./views/firebase-login-webview": 70349,
	"./views/firebase-login-webview.vue": 70349,
	"./views/index": 36125,
	"./views/index.vue": 36125,
	"./views/login": 64014,
	"./views/login.vue": 64014,
	"./views/maintenance": 31953,
	"./views/maintenance.vue": 31953,
	"./views/menu": 46039,
	"./views/menu.vue": 46039,
	"./views/my/editAddress": 16038,
	"./views/my/editAddress.vue": 16038,
	"./views/my/my": 86882,
	"./views/my/my.vue": 86882,
	"./views/my/mySecond": 55442,
	"./views/my/mySecond.vue": 55442,
	"./views/payment/appPayCenter": 94663,
	"./views/payment/appPayCenter.vue": 94663,
	"./views/payment/guavaPay": 53216,
	"./views/payment/guavaPay.vue": 53216,
	"./views/payment/orderSuccess": 1863,
	"./views/payment/orderSuccess.vue": 1863,
	"./views/payment/payDelay": 57894,
	"./views/payment/payDelay.vue": 57894,
	"./views/payment/payFail": 7528,
	"./views/payment/payFail.vue": 7528,
	"./views/payment/paypal": 96344,
	"./views/payment/paypal.vue": 96344,
	"./views/payment/paypalAdvance": 89695,
	"./views/payment/paypalAdvance.vue": 89695,
	"./views/payment/stripe": 62705,
	"./views/payment/stripe.vue": 62705,
	"./views/payment/trustPayment": 80162,
	"./views/payment/trustPayment.vue": 80162,
	"./views/payment/trustPaymentJs": 60047,
	"./views/payment/trustPaymentJs.vue": 60047,
	"./views/payment/vivaWallet": 46520,
	"./views/payment/vivaWallet.vue": 46520,
	"./views/policy/cookiePolicy": 64902,
	"./views/policy/cookiePolicy.vue": 64902,
	"./views/policy/faqs": 78309,
	"./views/policy/faqs.vue": 78309,
	"./views/policy/private": 74679,
	"./views/policy/private.vue": 74679,
	"./views/policy/refundAndCancellations": 47312,
	"./views/policy/refundAndCancellations.vue": 47312,
	"./views/policy/termsAndConditions": 23485,
	"./views/policy/termsAndConditions.vue": 23485,
	"./views/quick/quickLogin": 12423,
	"./views/quick/quickLogin.vue": 12423,
	"./views/review": 18335,
	"./views/review.vue": 18335,
	"./views/signup": 25419,
	"./views/signup.vue": 25419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;